import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";
import { axios } from "../../AxiosInstanceManager";

export async function getResourceById(resourceId: number | string) {
  try {
    const { data } = await axios.get<ResourceDWR>(`resource/${resourceId}`);
    if (!data.id) {
      // TODO have backend return a 404 or other error status code
      throw new Error("null resource");
    }
    return data;
  } catch (e: unknown) {
    throw new Error("null resource");
  }
}

export async function getResourceByHostRecordId(hostRecordId: string) {
  try {
    const { data } = await axios.get<ResourceDWR>(
      `/resource/byHostRecordId/${hostRecordId}`
    );
    if (!data.id) {
      // TODO have backend return a 404 or other error status code
      throw new Error("null resource");
    }
    return data;
  } catch (e: unknown) {
    throw new Error("null resource");
  }
}
